import type { StorefrontUiSettings } from "../../app/models/StorefrontResultsSettings";

export const DEFAULT_UI_SETTINGS: StorefrontUiSettings = {
    showCollectionFilteringNotice: true,
    filterShopifyKeywordSearch: false,
    limitVehicleSearchToCurrentCollection: false,
    keepShopifyFitmentTagsAligned: false,
    saveFitmentToCart: false,
    cartFitmentLabel: "",
    vehicleModal: { layout: "compact" },
    globalPrimaryColor: "#104190",
    globalSecondaryColor: "#000000",
    globalAccentColor: "#087f3f",
    globalSurfaceColor: "#ffffff",
    globalSubtleBackgroundColor: "#E1E3E4",
    globalTextColor: "#111111",
    globalInverseTextColor: "#ffffff",
    globalMutedTextColor: "#4b5563",
    globalBorderColor: "#D1D5DB",
    globalReviewStarColor: "#F5A623",
    colorOverrides: [],
    searchContentWidth: 1200,
    searchBorderRadius: 8,
    searchPadding: 10,
    searchBarBackground: "#E1E3E4",
    searchButtonBackground: "#104190",
    searchButtonText: "#ffffff",
    clearButtonBackground: "#ffffff",
    clearButtonText: "#111111",
    selectedVehicleBackground: "#104190",
    selectedVehicleUseGradient: false,
    selectedVehicleGradientEnd: "#104190",
    selectedVehicleFullWidth: true,
    selectedVehicleNameSize: 28,
    selectedVehiclePaddingTop: 10,
    selectedVehiclePaddingBottom: 10,
    selectedVehicleText: "#ffffff",
    changeButtonBackground: "#ffffff",
    changeButtonText: "#111111",
    disableResultStyles: false,
    resultsSortBy: "title-asc",
    showFitmentBadges: true,
    showStockStatus: true,
    showViewAsLabel: false,
    showVendor: false,
    showSku: false,
    showFitmentNotes: false,
    reviewDisplayMode: "none",
    showReviewCount: true,
    hoverAnimation: true,
    dynamicCardSizing: false,
    showGroupSelector: true,
    showPriceFilter: true,
    resultsFilterPlacement: 'toolbar',
    showFilterProductCounts: true,
    expandFilterSections: false,
    showResultsCount: true,
    showScrollTop: true,
    stickyGroupHeadings: false,
    stickyHeadingOffset: 0,
    enableViewToggle: true,
    defaultView: "grid",
    resultsContentWidth: 1200,
    productsPerRowDesktop: 4,
    productsPerRowTablet: 3,
    productsPerRowMobile: 2,
    cardImageHeight: 220,
    titleMaxLines: 0,
    minCardWidth: 220,
    headingBackground: "#111111",
    headingText: "#ffffff",
    cardBackground: "#ffffff",
    cardText: "#111111",
    buttonBackground: "#104190",
    buttonText: "#ffffff",
    exactBadgeColor: "#087f3f",
    universalBadgeColor: "#4b5563",
    hoverBorderColor: "#104190",
    reviewStarColor: "#F5A623",
    reviewEmptyStarColor: "#D1D5DB",
    buttonBehavior: "view-product",
};
